var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(" Demo's "), _c("w-spacer")], 1),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("w-select", {
                attrs: { items: _vm.modeSelectItems, value: _vm.mode },
                on: {
                  input: function ($event) {
                    return _vm.setMode($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("apexchart", {
                    ref: "chart",
                    attrs: {
                      height: 300,
                      options: _vm.chartOptions,
                      series: _vm.initialSeries,
                      type: "area",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }